import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as styles from '../shared/CheckboxListFilter.module.css';

/**
 * HostStatusFilter Component
 * Displays checkboxes for Host States (State Filter)
 */
function HostStatusFilter({ 
  hostStatuses = [], 
  selectedHostStatuses = [], 
  onHostStatusesChange,
}) {
  const { t } = useTranslation();

  /**
   * Handle host state checkbox change
   * @param {string} value - The state value
   */
  const handleHostStateChange = (value) => {
    const newSelection = selectedHostStatuses.includes(value)
      ? selectedHostStatuses.filter(s => s !== value)
      : [...selectedHostStatuses, value];
    onHostStatusesChange(newSelection);
  };

  return (
    <div className={styles.container}>
      <div className={styles.checkboxList}>
        {hostStatuses.length === 0 ? (
          <p className={styles.noStatusMessage}>{t('reports.filters.noStatesAvailable')}</p>
        ) : (
          hostStatuses.map((state) => (
            <label key={state.value} className={styles.checkboxItem} htmlFor={`host-state-${state.value}`}>
              <input
                id={`host-state-${state.value}`}
                type="checkbox"
                className={styles.checkbox}
                checked={selectedHostStatuses.includes(state.value)}
                onChange={() => handleHostStateChange(state.value)}
              />
              <span className={styles.checkboxLabel}>{state.label}</span>
            </label>
          ))
        )}
      </div>
    </div>
  );
}

HostStatusFilter.propTypes = {
  hostStatuses: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  selectedHostStatuses: PropTypes.arrayOf(PropTypes.string).isRequired,
  onHostStatusesChange: PropTypes.func.isRequired,
};

export default HostStatusFilter;

